import * as React from "react";
import {Form, Row, Col} from "react-bootstrap";


export default ({props}) => (
    <div> 
        <h5>Add project location</h5>  
    </div>
)